import { render, staticRenderFns } from "./MediosContacto.vue?vue&type=template&id=2cacac34&scoped=true&"
import script from "./MediosContacto.vue?vue&type=script&lang=js&"
export * from "./MediosContacto.vue?vue&type=script&lang=js&"
import style0 from "./MediosContacto.vue?vue&type=style&index=0&id=2cacac34&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cacac34",
  null
  
)

export default component.exports